import { GfsOfferDocumentPage } from "@/services/backend/gfs/offer/components/offer-document-page";

export default function GfsOfferDocumentRoute() {
  return <GfsOfferDocumentPage />;
}
